import { getUrl } from 'utils'
import VideoIcon from 'assets/svgr-icons/Video.svg'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'

export const listItemData = {
  id: 'videos',
  icon: VideoIcon,
  label: translate(T.VIDEOS_LABEL),
  url: getUrl('/home/my-projects/videos')
}
